import { Subcategory as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Subcategory = {
  id: string;
  categoryId: string;
  name: string;
};

export const fromGql = (item: GQLItem): Subcategory =>
  take(item, 'id', 'categoryId', 'name') as Subcategory;
